import BigNumber from 'bignumber.js'
import React, { useCallback, useMemo, useState } from 'react'
import styled from 'styled-components'
import { Button, Modal, Text, Toggle } from '@pancakeswap-libs/uikit'
import TicketInput from 'components/TicketInput'
import ModalActions from 'components/ModalActions'
import useI18n from 'hooks/useI18n'

interface ModalProps {
  max: string
  token: any
  isOwner?: boolean
  onConfirm?: (amount: string) => Promise<any>
  onDismiss?: () => void
}

const TheModal: React.FC<ModalProps> = ({ max, token, isOwner, onConfirm, onDismiss }) => {
  const [val, setVal] = useState('0')
  const [pendingTx, setPendingTx] = useState(false)
  const [, setRequested] = useState(false)
  const TranslateString = useI18n()

  const [sure, setSure] = useState(false)

  const handleChange = (e: React.FormEvent<HTMLInputElement>) => setVal(e.currentTarget.value)

  const isValid = (input) => {
    const value = new BigNumber(input);
    return value.isGreaterThan(0) && !value.isGreaterThan(max)
  }

  const handleSubmit = useCallback(async () => {
    try {
      setRequested(true)
      const txHash = await onConfirm(val);
      // user rejected tx or didn't go thru
      if (txHash) {
        setRequested(false)
      }
    } catch (e) {
      console.error(e)
    }
  }, [onConfirm, setRequested, val])

  const handleSelectMax = useCallback(() => {
    setVal(max)
  }, [max])

  return (
    <Modal title={`${TranslateString(509,'Inject')} ${token.symbol}`} onDismiss={onDismiss}>
      <TicketInput
        value={val}
        onSelectMax={handleSelectMax}
        onChange={handleChange}
        max={max}
        symbol={token.symbol}
        availableSymbol={token.symbol}
      />
      {
        !isOwner && (
          <div>
            <Announce>
              {TranslateString(493, 'You are adding')} {token.symbol} {TranslateString(494, 'to increase the balance of the ranch. This is usually done by the owner or the project team. The owner has the privilege to end the ranch and get the remaining balance in it. Make sure this is what you want. Ask the owner to renounce the ranch contract if you are concerned.')}
            </Announce>
            <ToggleContainer>
              <Text>{TranslateString(464, 'Confirm')}:</Text>
              <Toggle checked={sure} onChange={() => setSure(!sure)} />
            </ToggleContainer>
          </div>
        )
      }
      <ModalActions>
        <Button fullWidth variant="secondary" onClick={onDismiss}>
          {TranslateString(462, 'Cancel')}
        </Button>
        <Button
          fullWidth
          disabled={pendingTx || !isValid(val) || !(sure||isOwner)}
          onClick={async () => {
            setPendingTx(true)
            await handleSubmit()
            setPendingTx(false)
            onDismiss()
          }}
        >
          {pendingTx ? `${TranslateString(1072, 'Pending')}...` : TranslateString(320, 'Submit')}
        </Button>
      </ModalActions>
    </Modal>
  )
}

export default TheModal

const Announce = styled.div`
  margin-top: 1em;
  color: #f41e5b;
  text-align: center;
  max-width: 470px;
`

const Row = styled.div`
  margin-top: 25px;
`;

const ToggleContainer = styled(Row)`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  ${Text} {
    margin-right: 10px;
  }
`